export default "__VITE_ASSET__A3gtZ7mddHjILs2gEmqIOQ__"